import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { QueryClientProvider } from "@tanstack/react-query";
import queryClient from "./queryClient";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import "./index.css";
import theme from "./theme";
import App from "./App";
import { UserProvider } from "./hooks/user";
import { ImpersonationProvider } from "./hooks/impersonation";
import { Utitlity } from "./hooks/utility";
import { LoaderProvider } from "./context/LoaderContext";
import registerGlobalAxiosInterceptors from "./utils/registerGlobalAxiosInterceptors";

registerGlobalAxiosInterceptors();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />

    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <UserProvider>
          <ImpersonationProvider>
            <Utitlity>
              <LoaderProvider>
                <>
                  <ToastContainer autoClose={4000} />
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <App />
                  </LocalizationProvider>
                </>
              </LoaderProvider>
            </Utitlity>
          </ImpersonationProvider>
        </UserProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </ThemeProvider>
);
